import {
    LIST_DEFENSORIES,
    LIST_DEFENSORIES_SUCCESS,
    LIST_DEFENSORIES_ERROR,
    ADD_DEFENSORIES,
    SAVE_DEFENSORIES,
    SAVE_DEFENSORIES_SUCCESS,
    SAVE_DEFENSORIES_ERROR,
    EDIT_DEFENSORIES,
    UPDATE_DEFENSORIES,
    UPDATE_DEFENSORIES_SUCCESS,
    UPDATE_DEFENSORIES_ERROR,
    DELETE_DEFENSORIES,
    DELETE_DEFENSORIES_SUCCESS,
    DELETE_DEFENSORIES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    defensories: null,
    error: null,
    loading: false,
    defensorySelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_DEFENSORIES:
            return {
                ...state,
                loading: true
            }
        case LIST_DEFENSORIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_DEFENSORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                defensories: action.payload
            }
        case SAVE_DEFENSORIES:
        case DELETE_DEFENSORIES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_DEFENSORIES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_DEFENSORIES_ERROR:
        case UPDATE_DEFENSORIES_ERROR:
        case DELETE_DEFENSORIES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_DEFENSORIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                defensories: [...state.defensories, action.payload]
            }
        case ADD_DEFENSORIES:
            return {
                ...state,
                defensorySelected: null,
                isEdit: false
            }
        case EDIT_DEFENSORIES:
            return {
                ...state,
                defensorySelected: action.payload,
                isEdit: true
            }
        case UPDATE_DEFENSORIES_SUCCESS:
        case DELETE_DEFENSORIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                defensories: state.defensories.map(defensory => 
                    defensory.id === action.payload.id ? defensory = action.payload : defensory
                ),
                defensorySelected: null
            }
        // case DELETE_DEFENSORIES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         defensories: state.defensories.filter( defensory => defensory.id !== action.payload)
        //     }
        default:
            return state;
    }
}